module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.punctualArriveInfo.description) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\n  " + _vm._s(_vm.punctualArriveInfo.description) + "\n")]) : _vm._e(), _vm._v(" "), (_vm.punctualArriveInfo.supplier_id) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.supplier_name))]), _vm._v(" "), _c('div', {
    staticClass: "fw-bold border-bottom mt10",
    staticStyle: {
      "font-size": ".56rem",
      "padding-bottom": ".24rem"
    }
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.guaranteeStatusStr))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc mt24"
  }, [_c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.punctualArriveInfo.orderStatusTitle))]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.guaranteeDetailDesc))])]), _vm._v(" "), (_vm.punctualArriveInfo.headOfficeTel) ? _c('a', {
    staticClass: "btn-plain btn-yellow btn-kf",
    attrs: {
      "href": 'tel:' + _vm.punctualArriveInfo.headOfficeTel
    }
  }, [_vm._v("联系客服")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fs-32 fw-bold"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.content))]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.punctualArriveInfo.contentList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-row-bc mb24"
    }, [_c('div', {
      staticClass: "fw-bold"
    }, [_vm._v(_vm._s(item.contentKey))]), _vm._v(" "), _c('div', {
      staticClass: "fc-666"
    }, [_vm._v(_vm._s(item.contentValue))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "rule-list"
  }, _vm._l((_vm.punctualArriveInfo.ruleList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.overTimeDesc))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.compensateDesc))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rule-tips",
    on: {
      "click": function($event) {
        return _vm.viewRules()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.punctualArriveInfo.ruleTips)
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6d1ca28a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/PunctualArrive.vue
// module id = 449
// module chunks = 7